import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Network/WiFi/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/SystemPerm';
import DangerBox1 from 'components/Web_User_Interface/1440p_Series/Network/WiFi/DangerBox1';
import DangerBox2 from 'components/Web_User_Interface/1440p_Series/Network/WiFi/DangerBox2';
import DangerBox3 from 'components/Web_User_Interface/1440p_Series/Network/WiFi/DangerBox3';
import PrimaryBox from 'components/Web_User_Interface/1440p_Series/Network/WiFi/PrimaryBox';
import WiFiTable from 'components/Web_User_Interface/1440p_Series/Network/WiFi/wifiTable';
import WiFiAdHocTable from 'components/Web_User_Interface/1440p_Series/Network/WiFi/wifiAdHocTable';
import YoutubeVideoCardWPAEnterprise from 'components/Web_User_Interface/1440p_Series/Network/WiFi/YoutubeVideoCardWPAEnterprise';
import YoutubeVideoCardAdhoc from 'components/Web_User_Interface/1440p_Series/Network/WiFi/YoutubeVideoCardAdhoc';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
export const _frontmatter = {
  "title": "Netzwerk Menü // WLAN",
  "path": "/Web_User_Interface/1440p_Serie/Netzwerk/WLAN/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Ihre WiFi Verbindung sollte sich automatisch über WPS oder den Installation Wizard eingerichtet haben. Nutzen Sie den WiFi Scanner um Ihre Kamera mit einem anderen WiFi Netzwerk zu verbinden. Oder nutzen Sie die Suchergebnisse des Scanners um die Signalstärke am Installationspunkt der Kamera zu messen.",
  "image": "./WebUI_1440p_SearchThumb_Network_WiFi.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Network_WiFi.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">





    <SEOHelmet title='Netzwerk Menü // WLAN' dateChanged='2021-12-12' author='Mike Polinowski' tag='INSTAR IP Camera' description='Ihre WiFi Verbindung sollte sich automatisch über WPS oder den Installation Wizard eingerichtet haben. Nutzen Sie den WiFi Scanner um Ihre Kamera mit einem anderen WiFi Netzwerk zu verbinden. Oder nutzen Sie die Suchergebnisse des Scanners um die Signalstärke am Installationspunkt der Kamera zu messen.' image='/images/Search/WebUI_1440p_SearchThumb_Network_WiFi.png' twitter='/images/Search/WebUI_1440p_SearchThumb_Network_WiFi.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/Web_User_Interface/1440p_Series/Network/WiFi/' locationFR='/fr/Web_User_Interface/1440p_Series/Network/WiFi/' crumbLabel="WiFi" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "netzwerk-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#netzwerk-men%C3%BC",
        "aria-label": "netzwerk menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Netzwerk Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/121b3/1440p_Settings_Network_WLAN.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACTUlEQVQoz12Ry04TARSGeQsTdMMGpsW2RmgLUdpO59bOpTOde6EUCihKryJgdOUCEGiN4AP4ACJr49N9hoLGuPhyNidfzvn/qVQqRUKYQ9k5xf74E/PDDfr7G9Sja6SDa+TDW37czzukw2u0o+8Ex79weyMeTT9gevohMzMzTCWT8wjCHFq8RzwcEXROiAdnxMMLosEFYe8Mr3NK0D8n7J9N8LufCLonrO2PMRp7pFMZnmQWSD1OMzU/P08ikUCWRLwgnNDaaNPe2qG9tc3G5hZBGOPWbTw/wA9CXM/HcT3qro9RrVAWZcqiSja7dC8UZpGtGKf/BfP1BXZnhNcf43TH1Dojat0xTnsftzfGG14Rv73CG15S719Sj2KUcoFiQWJxIf/vhRKObWHoVSxDR1MVKqqCZRqYqoJjGJimgV7VkKUyge8y6PdZbdhoSoHCikQut3SbYRJBEFBUlWazSSOOCYIA13UnhFFE5Hm4tk1VN5AkGVEso8gyhm7g1KrIYhFZFFnO5++ECUGYLFqOj1GrU6//h+tiOw66XkWRSpO8S4rM87JEzVBRxCKaLJLL5u5eFhIJqqrEm7bDXrM2kTiO85dbWa1mUdFN1Po6FbvBqqwQixItz8RUSpQKIouL98JZIYGjS3x7Z3M1sPB9f0IYBERhQCOKWI1DmpsvaR19Zb13zLkb8tmLOWj5dNYqFIoS+T8Z3paSSmdIZhZIpp+Sy+VZXlpGKz3DkldYtTV21yMG3V3WAxtb1/Btg+1XL4irEq6yTC6bJZVK8xs1JIL9iWdd4QAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/52e4c7cc2355ed387b4fe4846327fcfc/e4706/1440p_Settings_Network_WLAN.avif 230w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/d1af7/1440p_Settings_Network_WLAN.avif 460w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/7f308/1440p_Settings_Network_WLAN.avif 920w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/07541/1440p_Settings_Network_WLAN.avif 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/52e4c7cc2355ed387b4fe4846327fcfc/a0b58/1440p_Settings_Network_WLAN.webp 230w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/bc10c/1440p_Settings_Network_WLAN.webp 460w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/966d8/1440p_Settings_Network_WLAN.webp 920w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/893d8/1440p_Settings_Network_WLAN.webp 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/52e4c7cc2355ed387b4fe4846327fcfc/81c8e/1440p_Settings_Network_WLAN.png 230w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/08a84/1440p_Settings_Network_WLAN.png 460w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/c0255/1440p_Settings_Network_WLAN.png 920w", "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/121b3/1440p_Settings_Network_WLAN.png 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/52e4c7cc2355ed387b4fe4846327fcfc/c0255/1440p_Settings_Network_WLAN.png",
              "alt": "Web User Interface - 1440p Series - Network WiFi",
              "title": "Web User Interface - 1440p Series - Network WiFi",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBox1 mdxType="DangerBox1" />
    <EuiSpacer mdxType="EuiSpacer" />
    <WiFiTable mdxType="WiFiTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardWPAEnterprise mdxType="YoutubeVideoCardWPAEnterprise" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h3 {...{
      "id": "was-ist-ad-hoc",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#was-ist-ad-hoc",
        "aria-label": "was ist ad hoc permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Was ist Ad-Hoc?`}</h3>
    <p>{`Im Gegensatz zum Infrastrukturmodus, bei dem sich die Kamera mit Ihrem WiFi-Heimnetzwerk verbindet, erstellt die Kamera im Ad-Hoc-Modus ihren eigenen WiFi-Zugangspunkt. Clients, wie z. B. Smartphones, können sich direkt mit dem Ad-Hoc-WiFi-Netzwerk der Kamera verbinden und über die IP-Adresse `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`192.168.9.1`}</code>{` auf die Kamera zugreifen.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/364195d3ab7f109772232acb65ab53b3/121b3/1440p_Settings_Network_AdHoc_WLAN.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "48.26086956521739%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACO0lEQVQoz12R2U7bQBSGeYtKtDfcFMeQpCokISqEJLbjeEnGcWa8hACVgFKJXSwVd5VaVWLpwgv0voXrqm/3VTbQSr34NHN05v91zj8TxWKRgjaNtfkJ8f4X/vkd7vkdnbNbjJOfmBmnt/n5WBsnt9hnP1AffxPuXfJs8gmTk0+ZmppiQtdn0KansZMd0uOvRPsXJIdXxIfXRBkHV8i9i7xOjr6QHH1G7l+i9i8Yn37DH+1Qmi3zojxHcbbExMzMDAVdx2guMvAs+o7JwLcZ9ruEPZvAs5DCYS0ZMo4HrCYhIykQbvbWwLMt2q2MDpXKwr2hrus0W23srkPbMOnYXRzXo+u4eZ3h+T1cz8fv9RHBgF5f4Lg+QrhYRpPlhsH8XO1hwkKBdrtNEAS4rpvj+z79fh/P83AcJ++laUocx0gpkXLIUCoi5dHtNFhaNKhWF7IMdbRCgY5lMcoFUS7KiKJ/d6VUbpimI6IoRkmJUhHDwMNoNjBbLeq12oOhpmGaFgOVIEKVi/8nm2o0SkljRayGBFISRBGhcDGbDWyzRbVSvV9Z0wo4tsnxRsjumiAMw78MMgZhvrKMUuT6Dmr8hi0xYLMneK0EntWkudxifv7B8LlWIHANvr8T3Bz4DxlJIiWJI0USx4wSxcr6FqtnN4x3P3ARRlyHMSdrQ3ZWujSWDWqPGWafUiyV0ctz6KWXVKs16gt17OYreuYSI2GzvRpzsLfNmhIIz0YKj423WySOQWjVqVYqFIsl/gArDIAAG4lVDQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/364195d3ab7f109772232acb65ab53b3/e4706/1440p_Settings_Network_AdHoc_WLAN.avif 230w", "/de/static/364195d3ab7f109772232acb65ab53b3/d1af7/1440p_Settings_Network_AdHoc_WLAN.avif 460w", "/de/static/364195d3ab7f109772232acb65ab53b3/7f308/1440p_Settings_Network_AdHoc_WLAN.avif 920w", "/de/static/364195d3ab7f109772232acb65ab53b3/07541/1440p_Settings_Network_AdHoc_WLAN.avif 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/364195d3ab7f109772232acb65ab53b3/a0b58/1440p_Settings_Network_AdHoc_WLAN.webp 230w", "/de/static/364195d3ab7f109772232acb65ab53b3/bc10c/1440p_Settings_Network_AdHoc_WLAN.webp 460w", "/de/static/364195d3ab7f109772232acb65ab53b3/966d8/1440p_Settings_Network_AdHoc_WLAN.webp 920w", "/de/static/364195d3ab7f109772232acb65ab53b3/893d8/1440p_Settings_Network_AdHoc_WLAN.webp 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/364195d3ab7f109772232acb65ab53b3/81c8e/1440p_Settings_Network_AdHoc_WLAN.png 230w", "/de/static/364195d3ab7f109772232acb65ab53b3/08a84/1440p_Settings_Network_AdHoc_WLAN.png 460w", "/de/static/364195d3ab7f109772232acb65ab53b3/c0255/1440p_Settings_Network_AdHoc_WLAN.png 920w", "/de/static/364195d3ab7f109772232acb65ab53b3/121b3/1440p_Settings_Network_AdHoc_WLAN.png 1070w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/364195d3ab7f109772232acb65ab53b3/c0255/1440p_Settings_Network_AdHoc_WLAN.png",
              "alt": "Web User Interface - 1440p Series - Network WiFi",
              "title": "Web User Interface - 1440p Series - Network WiFi",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <EuiSpacer mdxType="EuiSpacer" />
    <WiFiAdHocTable mdxType="WiFiAdHocTable" />
    <EuiSpacer mdxType="EuiSpacer" />
    <EuiSpacer mdxType="EuiSpacer" />
    <YoutubeVideoCardAdhoc mdxType="YoutubeVideoCardAdhoc" />
    <EuiSpacer mdxType="EuiSpacer" />
    <h2 {...{
      "id": "kamera-reset--wps",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#kamera-reset--wps",
        "aria-label": "kamera reset  wps permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Kamera Reset & WPS`}</h2>
    <p>{`Wenn Sie die Reset-Taste an Ihrer Kamera drücken, werden die Status-LEDs ausgeschaltet und...`}</p>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Nach 3s`}</strong>{`: Schalten sich die Status-LEDs ein und es starten, nach dem Loslassen der Taste, den `}<a parentName="li" {...{
          "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/WLAN/"
        }}>{`Wireless-Protected-Setup`}</a>{` Modus oder `}<strong parentName="li">{`WPS`}</strong>{`, mit dem Sie Ihre Kamera zu Ihrem lokalen WiFi hinzufügen können. Drücken Sie die Taste nocheinmal `}<strong parentName="li">{`für 2s`}</strong>{`, um den Modus vor der regulären 2-minütigen Laufzeit zu beenden.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 15s`}</strong>{`: Beginnen die Status-LEDs langsam zu blinken und es werden, nach dem Loslassen der Taste, alle Kameraeinstellungen `}<strong parentName="li">{`mit Ausnahme der Netzwerkkonfiguration`}</strong>{` zurückgesetzt.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 20s`}</strong>{`: Beginnen die Status-LEDs schnell zu blinken und es werden, nach dem Loslassen der Taste, `}<strong parentName="li">{`ALLE`}</strong>{` Kameraeinstellungen zurückgesetzt.`}</li>
      <li parentName="ol"><strong parentName="li">{`Nach 30s`}</strong>{`: Gehen die Status-LEDs aus und die Kamera wird in den Zustand vor dem letzten Firmware-Update zurückgesetzt. Anschließend startet die Kamera neu.`}</li>
    </ol>
    <p>{`Falls Sie den `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/Herstellen_der_WLAN_Verbindung/WPS_Plug_and_Play/"
      }}>{`WPS Service`}</a>{`  (`}<strong parentName="p">{`W`}</strong>{` ireless `}<strong parentName="p">{`P`}</strong>{` rotected `}<strong parentName="p">{`S`}</strong>{` etup) nicht nutzen können, folgen Sie bitte unserer `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/Herstellen_der_WLAN_Verbindung/"
      }}>{`Anleitung für die WLAN Einbindung`}</a>{`. Starten Sie den Scanner und wählen Sie Ihr Netzwerk aus und Klicken auf „Beitreten“. Jetzt müssen Sie Ihr WiFi Passwort eingeben und die Einstellungen bestätigen. Danach können Sie die `}<strong parentName="p">{`Test`}</strong>{` Funktion nutzen um Ihre Einstellungen zu überprüfen. Bitte entfernen Sie das LAN Kabel und starten die Kamera neu - einfach das Netzteil für 3 Sekunden entfernen. Die Kamera wird automatisch - innerhalb von `}<strong parentName="p">{`max. 5 Minuten`}</strong>{` - mit Ihrem WiFi Netzwerk verbinden. Das WiFi Modul der Kamera wird eine neue Adresse vom Ihrem Router erhalten - falls Sie keine `}<a parentName="p" {...{
        "href": "/de/Web_User_Interface/1440p_Serie/Netzwerk/IP_Konfiguration/"
      }}>{`statische IP Adresse`}</a>{` für Ihre Kamera festgelegt hatten. Sie müssen daher, eventuell, das `}<a parentName="p" {...{
        "href": "/de/Schnell_Installation/Alternative_IP_Scanner/"
      }}>{`INSTAR Kamera Tool`}</a>{` erneut nutzen, um Ihre Kamera wieder zu finden. Ihre Kamera ist jetzt mit dem WLAN verbunden!`}</p>
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBox3 mdxType="DangerBox3" />
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBox2 mdxType="DangerBox2" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PrimaryBox mdxType="PrimaryBox" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      